import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
export const titleAndAdditionalInfoContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'row',
    align_items: 'center',
    gap: FOUNDATIONS.spacing_100,
});
export const titleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_200,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_50,
});
export const placeholderCommonStyles = (FOUNDATIONS, FONT) => ({
    font_size: FONT.font_paragraph_200[DeviceBreakpointsType.DESKTOP].font_size,
    line_height: FONT.font_paragraph_200[DeviceBreakpointsType.DESKTOP].line_height,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_comp_forms_input_empty_font,
});
export const helpMessageErrorContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
});
export const helpMessageCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
});
export const counterCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_150,
});
//# sourceMappingURL=text.js.map